/** Reglas de adjuntos de gastos y pagos: mismas extensiones y tamaño máximo que el backend (app/adjuntos/reglas.py). */
export const EXTENSIONES_ADJUNTO = ["pdf", "jpg", "jpeg", "png", "webp", "heic"];
export const ACCEPT_ADJUNTO = ".pdf,.jpg,.jpeg,.png,.webp,.heic,application/pdf,image/*";
export const MAX_BYTES_ADJUNTO = 10 * 1024 * 1024;
/** Tope de adjuntos por gasto, pago o aporte (el backend responde 409 "Ya hay 10 adjuntos"). */
export const MAX_ADJUNTOS = 10;

/** Qué archivos acepta un `Adjuntos`: por defecto PDF e imágenes; el plano y los renders, sólo imágenes; la maqueta, un .glb. */
export interface TiposAdjunto {
  extensiones: string[];
  accept: string;
  mensaje: string;
}

export const TIPOS_ADJUNTO: TiposAdjunto = { extensiones: EXTENSIONES_ADJUNTO, accept: ACCEPT_ADJUNTO, mensaje: "Sólo se aceptan PDF e imágenes (JPG, PNG, WEBP, HEIC)" };
/** Lo que se muestra en la página (plano y renders de una unidad): como `IMAGENES` de app/adjuntos/reglas.py. */
export const TIPOS_IMAGEN: TiposAdjunto = { extensiones: ["jpg", "jpeg", "png", "webp"], accept: ".jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp", mensaje: "Sólo se aceptan imágenes JPG, PNG o WEBP" };
/** La maqueta 3D del edificio: como `MAQUETA` de app/adjuntos/reglas.py. */
export const TIPOS_MAQUETA: TiposAdjunto = { extensiones: ["glb"], accept: ".glb,model/gltf-binary", mensaje: "La maqueta tiene que ser un archivo .glb" };

export function validarArchivo(archivo: File, tipos: TiposAdjunto = TIPOS_ADJUNTO): string | null {
  const ext = archivo.name.split(".").pop()?.toLowerCase() ?? "";
  if (!archivo.name.includes(".") || !tipos.extensiones.includes(ext)) return tipos.mensaje;
  if (archivo.size > MAX_BYTES_ADJUNTO) return "El archivo supera los 10 MB";
  return null;
}

const kb = new Intl.NumberFormat("es-AR", { maximumFractionDigits: 1 });

export function formatTamanio(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${kb.format(bytes / 1024)} KB`;
  return `${kb.format(bytes / (1024 * 1024))} MB`;
}
